
let COLOR = {
  lightGreen: '#00d7af',
  lightWhite: '#f8f8ff',
  lightGrey: '#e0e0e0',
  lightBlack: '#343a42',
  black: '#000000',
  white: '#ffffff',
  red: '#dc3547',
  blue: '#007bfb',
  yellow: '#ffc108',
  cyan: '#17a2b9',
  grey: '#6c757e',
  green: '#28a748',
  orange: '#ffa500',
  transparent: 'rgba(255, 255, 255, 0)'
};

export { COLOR };
